import { EventName, createComponent } from '@lit/react';
import { BlocksImageGallery } from 'blocks-nextjs/blocks-web-components/components/image-gallery/image-gallery';
import { BlocksThumbnailSelect } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';

export const CatImageGallery = createComponent({
  react: React,
  tagName: 'cat-image-gallery',
  elementClass: BlocksImageGallery,
  events: {
    onBlThumbnailSelect: 'bl-thumbnail-select' as EventName<BlocksThumbnailSelect>
  }
});
